import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ui from 'redux-ui';
import './InteractiveLayerContainer.css';
import InteractiveLayer from '../interactive-layer/InteractiveLayer';
import TextToImage from '../text-to-image/TextToImage';
import {
  MmToPx,
  showAlertModal,
  generatePreview,
} from './../../redux/helpers';
import { getTextWrapper } from './../../redux/helpers/texts';
import { changeTextProperty } from './../../redux/actions/entities/texts';
import { guestBook, placeCard } from './../../helpers/weddingHelper';


class InteractiveLayerContainer extends Component {
  constructor(args) {
    super(args);
    this.coverSize = 0;
    this.innerPageSize = 0;
    this.pageRatio = 1;
    this.dragRef = '';
    this.spineRef = '';
    this.InteractiveLayerContainer = '';
  }


  componentDidUpdate(prevProps) {
    const { layouts, activePageId, pages } = this.props;
    const { layouts: prevLayouts, activePageId: prevActivePageId, pages: prevPages } = prevProps;
    if (prevLayouts[prevPages[prevActivePageId].layout] !== layouts[pages[activePageId].layout]) {
      if (layouts[pages[activePageId].layout]) {
        this.innerPageSize = MmToPx(parseInt(layouts[pages[activePageId].layout].width, 10));
      }
    }

    const { pageNumber, isOrder } = this.props;
    const { pageNumber: prevNumber } = prevProps;
    const { folderId } = this.props.bookproperties;

    if (pageNumber === 1 && isOrder) {
      const { pages } = this.props;
      const pagesLength = Object.keys(pages).length;

      const activePage = Object.values(pages).find(element => element.isActive);
      generatePreview(this.props.dispatch, pageNumber - 1, pagesLength, folderId);
    }
  }


  getCoverMarginType = () => {
    const { bookproperties } = this.props;
    return bookproperties;
  }

  getActiveText = () => {
    const { text } = this.props;
    return Object.values(text).find(element => (element ? element.isActive : ''));
  }

  resizeMargin = () => {
    const container = this.InteractiveLayerContainer;
    const { layouts, activePageId, pages } = this.props;
    if (container) {
      if (layouts[pages[activePageId].layout]) {
        this.innerPageSize = MmToPx(parseInt(layouts[pages[activePageId].layout].width, 10));
      }
      this.pageRatio = this.innerPageSize / container.clientWidth;
    }
  }


  removeActiveTextClass = () => {
    const {
      id,
      text,
    } = this.getActiveText();
    const {
      title_notice,
      emptyTextInputAlert,
    } = this.props.lang;
    if (text === '') {
      return showAlertModal(title_notice, emptyTextInputAlert);
    }
    return this.props.dispatch(changeTextProperty(id, 'isActive', false));
  }

  render() {
    this.resizeMargin();
    const {
      ui,
      pageNumber,
      placeholders,
      spine,
      photoCover,
      backgroundColor,
      allowRender,
      lang,
      coverLayoutWidth,
      bookproperties,
      text,
      EditorLimit,
      backgroundImage,
      backgroundPlaceholders,
      pages,
      layouts,
      activePageId,
    } = this.props;

    const { marginType } = ui;
    const bookMargin = 0;
    let pageMargin = bookMargin;
    const bookId = bookproperties.photoBookId;

    if (layouts[pages[activePageId].layout]) {
      pageMargin = layouts[pages[activePageId].layout].margins;
    }

    const marginSizes = {
      top: MmToPx(pageMargin.top) / this.pageRatio,
      left: MmToPx(pageMargin.left) / this.pageRatio,
      right: MmToPx(pageMargin.right) / this.pageRatio,
      bottom: MmToPx(pageMargin.bottom) / this.pageRatio,
    };


    // 10mm before margin

    const BeforeMarginLimit = MmToPx(0) / this.pageRatio;
    const TextWrapper = getTextWrapper({
      left: bookMargin,
      top: bookMargin,
      right: bookMargin,
      bottom: bookMargin,
    }, EditorLimit, BeforeMarginLimit);

    const pageText = Object.values(text).filter(element => (element ? !element.isSpineText : ''));
    const activeText = this.getActiveText();

    const currentLayout = layouts[pages[activePageId].layout];
    const isGuestBook = currentLayout ? currentLayout.type === guestBook : false;
    const isPlaceCard = currentLayout ? currentLayout.type === placeCard : false;

    const GuestBookMarker = MmToPx(152) / this.pageRatio;
    const GuestBookStyle = {
      right: GuestBookMarker,
    };

    return (
      <div className="InteractiveLayerContainer" ref={(layer) => { this.InteractiveLayerContainer = layer; }}>
        <InteractiveLayer
          spine={spine}
          pageNumber={pageNumber}
          placeholders={placeholders}
          backgroundPlaceholders={backgroundPlaceholders}
          isPhotoCover={photoCover}
          backgroundColor={backgroundColor}
          backgroundImage={backgroundImage}
          allowRender={allowRender}
          lang={lang}
          coverLayoutWidth={coverLayoutWidth}
          context={bookproperties.context}
        />
        <div
          data-html2canvas-ignore="true"
          className={`margintype top ${marginType || ''}`}
          style={{
            height: marginSizes.top,
            left: 0,
            right: 0,
            top: 0,
          }}
        />
        <div
          data-html2canvas-ignore="true"
          className={`margintype left ${marginType || ''}`}
          style={{
            bottom: marginSizes.bottom,
            left: 0,
            top: marginSizes.top,
            width: marginSizes.left,
          }}
        />
        <div
          data-html2canvas-ignore="true"
          className={`margintype right ${marginType || ''}`}
          style={{
              bottom: marginSizes.bottom,
              right: 0,
              top: marginSizes.top,
              left: 'initial',
              width: marginSizes.right,
            }}
        />
        <div
          data-html2canvas-ignore="true"
          className={`margintype bottom ${marginType || ''}`}
          style={{
            bottom: 0,
            height: marginSizes.bottom,
            left: 0,
            top: 'initial',
            right: 0,
          }}
        />

        { activeText && <div className="text-overlay" onClick={this.removeActiveTextClass} /> }

        { TextWrapper.map((wrapper, index) => (
          <div
            ref={(dragRef) => { this.dragRef = dragRef; }}
            className="dragLimit"
            style={wrapper}
            key={`dragLimit-${index}`}
          >
            { Object.values(pageText).map(item => (

              <TextToImage
                key={item.id}
                id={item.id}
                text={item.text}
                images={item.images}
                style={item.positions}
                isActive={item.isActive}
                marginLimit={BeforeMarginLimit}
                pageRatio={this.pageRatio}
                dragWrapper={this.dragRef}
                spineRef={this.spineRef}
                imageWidth={item.images ? item.images.thumbnail.width : 0}
                layerRef={this.InteractiveLayerContainer}
                bookId={bookId}
              />))
            }
          </div>
          )) }

        { isGuestBook &&
          <div style={GuestBookStyle} className="guestcenter">
            <span>{lang.guestbookText}</span>
            <div className="guestcenter-line" />
          </div>
        }

        {
          isPlaceCard &&
          <div className="placeCardCenter">
            <span>{lang.placeCardText}</span>
            <div className="guestcenter-line" />
          </div>
        }

      </div>
    );
  }
}

InteractiveLayerContainer.defaultProps = {
  pageNumber: 1,
  spine: {},
  photoCover: false,
  backgroundColor: '#fff',
  allowRender: false,
  lang: {},
  coverLayoutWidth: 1100,
  bookproperties: {},
  placeholders: [],
  text: [],
  EditorLimit: {},
  backgroundImage: '',
};

InteractiveLayerContainer.propTypes = {
  pageNumber: PropTypes.number,
  spine: PropTypes.object,
  photoCover: PropTypes.bool,
  backgroundColor: PropTypes.string,
  allowRender: PropTypes.bool,
  lang: PropTypes.object,
  coverLayoutWidth: PropTypes.number,
  bookproperties: PropTypes.object,
  placeholders: PropTypes.array,
  text: PropTypes.array,
  EditorLimit: PropTypes.object,
  backgroundImage: PropTypes.string,
};


InteractiveLayerContainer = ui({
  key: 'EditorToolsUI',
  state: { marginType: '' },
})(InteractiveLayerContainer);

export default connect(state => ({
  bookproperties: state.bookProperties,
  spineColor: state.entities.cover.spine.backgroundColor,
  isOrder: state.editorUI.isOrder,
  layouts: state.entities.layouts.byId,
}
))(InteractiveLayerContainer);



// WEBPACK FOOTER //
// ./src/components/interactive-layer-container/InteractiveLayerContainer.jsx